<template>
    <div style="min-width: 120px">
        <select class="form-control" v-model="$i18n.locale" v-on:change="setLocale">
            <option v-for="(lang, i) in locales" :key="`Lang${i}`" :value="lang">{{ $t(`lang_${lang}`) }}</option>
        </select>
    </div>
</template>

<script>
import { locales } from '@/services/translationService';

export default {
    name: 'locale-changer',
    data() {
        return {
            locales
        };
    },
    methods: {
        setLocale: e => {
            localStorage.setItem('locale', e.target.value);
        }
    }
};
</script>
